import { render, staticRenderFns } from "./AppScene.vue?vue&type=template&id=2bc83e67&scoped=true&lang=html&"
import script from "./AppScene.vue?vue&type=script&lang=js&"
export * from "./AppScene.vue?vue&type=script&lang=js&"
import style0 from "./AppScene.vue?vue&type=style&index=0&id=2bc83e67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc83e67",
  null
  
)

export default component.exports